import { formatE1rm, formatWeight, type WeightUnitLabels } from '@heraion/shared';

import type { detectOutliersForDraft } from './detectOutliersForDraft';
import type { WeightUnit } from './state/loggerDraft';

// The save prompt's outlier lines, out of useSaveWorkout under the file-size
// cap. One line per finding, joined as a bullet list.

export function outlierPromptItems(
  outliers: ReturnType<typeof detectOutliersForDraft>,
  t: (k: string, opts?: Record<string, unknown>) => string,
  locale: string,
  defaultUnit: WeightUnit,
  unitLabels: WeightUnitLabels,
): string {
  return outliers
    .map((o) => {
      if (o.reason === 'reps') {
        return t('workout.outlierRepsItem', {
          exercise: o.exerciseName,
          reps: o.reps,
        });
      }
      if (o.reason === 'zero-weight') {
        return t('workout.outlierZeroWeightItem', {
          exercise: o.exerciseName,
          reps: o.reps,
        });
      }
      if (o.reason === 'e1rm-jump') {
        // PG-49: both values are e1RM estimates, so `formatE1rm`; the
        // other reasons format real plates with `formatWeight`.
        return t('workout.outlierE1rmItem', {
          exercise: o.exerciseName,
          e1rm: formatE1rm(o.e1rmKg ?? 0, defaultUnit, locale, unitLabels),
          expected: formatE1rm(o.expectedMaxKg, defaultUnit, locale, unitLabels),
        });
      }
      if (o.reason === 'per-implement-double') {
        return t('workout.outlierPerImplementItem', {
          exercise: o.exerciseName,
          weight: formatWeight(o.weightKg, defaultUnit, locale, unitLabels),
          expected: formatWeight(o.expectedMaxKg, defaultUnit, locale, unitLabels),
        });
      }
      return t('workout.outlierItem', {
        exercise: o.exerciseName,
        weight: formatWeight(o.weightKg, defaultUnit, locale, unitLabels),
        expected: formatWeight(o.expectedMaxKg, defaultUnit, locale, unitLabels),
      });
    })
    .join('\n• ');
}
